<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12" md="8">
                <b-card header="Player" class="text-left" style="min-height: 502px">
                    <loading :active="tracksLoadStatus == 1"></loading>
                    <template v-if="tracksLoadStatus == 2">
                        <c-main-player :ptracks="ptracks"></c-main-player>
                    </template>
                </b-card>
            </b-col>

            <b-col sm="12" md="4">
                <b-card header="Comments" class="text-left">
                    <span style="font-size: medium;">
                        <b class="text-primary">someone1@yopmail.com:</b>
                        Beautiful song. Remind me of my childhood.
                    </span>
                    <br />
                    <br />
                    <span style="font-size: medium;">
                        <b class="text-primary">someone2@yopmail.com:</b>
                        I cried already...
                    </span>
                    <br />
                    <br />
                    <span style="font-size: medium;">
                        <b class="text-primary">someone3@yopmail.com:</b>
                        Listened to it already 100 times
                    </span>
                    <br />
                    <br />
                    <span style="font-size: medium;">
                        <b class="text-primary">someone4@yopmail.com:</b>
                        She must be an angel
                    </span>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cMainPlayer from './../../components/Player/MainPlayer.vue'
export default {
    name      : 'TrackDetails',
    components: { cMainPlayer },
    created () {
        // Load album tracks
        this.$store.dispatch('player/getTrack', this.$route.params.id)
    },
    computed:{
        ptracks(){
            return this.$store.state.player.ptracks;
        },
        tracksLoadStatus(){
            return this.$store.state.player.tracksLoadStatus;
        },
    }
}
</script>

<style>
.card-body {
    padding: 5px;
}
</style>
